// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e57f9e07","527":"ed2a5aaa","787":"d4aba7ab","791":"f7638411","792":"6082a4f3"}[chunkId] + ".chunk.js";
};